import React from 'react';
import AnimateHeight from 'react-animate-height';
import { dispatch, useReframe } from 'nike-re-framejs';

import { fireGAEvent } from '@/analytics';
import { InfoPaper, WarningPaper } from '@/common/components/surfaces/Paper';
import { Color } from '@/common/Color';
import { Box } from '@/common/components/layout/Box';
import { closeServerOutage } from '@/server/handlers';
import { serverInfoOdstavka$, serverIsOdstavkaClosed$ } from '@/server/subs';

function Odstavka() {
    const { subscribe } = useReframe();
    const odstavka = subscribe(serverInfoOdstavka$);

    return (
        <div className="animate-height-fix-ios">
            <AnimateHeight height={odstavka ? 'auto' : 0}>
                {odstavka ? (
                    <Box className="module-info-box" spacing={6}>
                        {odstavka
                            // na desktope sa informacie zobrazuju nad userboardom (nad hlavickou)
                            .map(item => (
                                <div key={item.id}>
                                    {item.priorita === 'VYPADOK' ? <TypeVypadok item={item} /> : null}
                                    {item.priorita === 'INFORMACIA' ? <TypeInformacia item={item} /> : null}
                                    {item.priorita === '' ? <TypeInformacia item={item} /> : null}
                                </div>
                            ))}
                    </Box>
                ) : (
                    <noscript />
                )}
            </AnimateHeight>
        </div>
    );
}

const TypeVypadok = ({ item }) => <WarningPaper>{item.sprava}</WarningPaper>;

export function TypeInformacia({ item }) {
    const { subscribe } = useReframe();
    const isClosed = subscribe(serverIsOdstavkaClosed$(item.id));
    function handleCloseClick() {
        fireGAEvent('Homepage', 'Zatvorenie alertu', 'Alerty');
        dispatch(closeServerOutage(item.id));
    }
    return isClosed ? null : (
        <InfoPaper closeAction={handleCloseClick} color={Color.paleGray}>
            {item.sprava}
        </InfoPaper>
    );
}

export default Odstavka;
